module.exports = __webpack_public_path__ + "img/aseguradora-1.8fb178a7.png";